// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-tooltip-docs',
    templateUrl: './tooltip.docs.generated.html',
})
export class UITooltipDocs { }
